// 🤖 AUTO-GENERATED from data/components.json
// DO NOT EDIT MANUALLY - Changes will be overwritten
// Schema version: 1.0.0

import type { VoltraBaseProps } from '../baseProps'

export type VStackProps = VoltraBaseProps & {
  /** Spacing between children */
  spacing?: number
  /** Horizontal alignment */
  alignment?: 'leading' | 'center' | 'trailing'
}
